import { render, staticRenderFns } from "./EmployeeRecords.vue?vue&type=template&id=1f1568b4&scoped=true&"
import script from "./EmployeeRecords.vue?vue&type=script&lang=js&"
export * from "./EmployeeRecords.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRecords.vue?vue&type=style&index=0&id=1f1568b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1568b4",
  null
  
)

export default component.exports